import React, {Component} from 'react';
import {Card, CardHeader} from 'material-ui/Card';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import Factura from '../../Models/Factura.js';
import Close from '../../components/Buttons/CloseButton.jsx';
import Input from './Input.jsx';
import _ from 'underscore';
import RetIvaActions from '../../reflux/RetIvaActions';
import RetIvaFormStore from '../../reflux/stores/RetIvaFormStore';
import moment from 'moment';

import Plus from '../../components/Buttons/Plus.jsx';
import Remove from '../../components/Buttons/Remove.jsx';

const cardStyle = {paddingRight:20, paddingLeft: 20, paddingTop:10, paddingBottom:20, marginBottom:5};
const cardHeaderStyle = {textAlign:'center', paddingBottom:0 };
const cardHTextStyle = {paddingRight:0};

class FacturaForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: true,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.updateModel = this.updateModel.bind(this);
    }


    componentDidMount() {
        this.unsubscribe = RetIvaFormStore.listen(this.updateModel);
    }
    componentWillUnmount() {
        this.unsubscribe();
    } 
    
    /**
     * Handle input change (text fields, date fields, etc)
     * 
     * @parem e Event The Event fired
     * @param value Variant The value of the field that has changed
     */
    handleInputChange(e, value, blur) {
        const offset = this.props.factura.iva_offset;
        //DECIMAL ADJUST
        if ((e === 'plus' && offset < 5) || (e === 'minus' && offset > -5)) {
            let val = e === 'plus'
            ? (parseInt(this.props.factura.iva_offset)+1).toFixed(2)
            : (parseInt(this.props.factura.iva_offset)-1).toFixed(2);
            e = {target: {value: val, name:'iva_offset'}};

            RetIvaActions.inputChange(e, this.props.factura, this.props.line);
        }

        if (e.hasOwnProperty('target'))
            RetIvaActions.inputChange(e, this.props.factura, this.props.line, blur);

        if (e.hasOwnProperty('name') && e.name === 'numeroDoc' && !this.state.isActive) {
            let hide = value.length < 1 ? false : true;
            this.setState({isActive:hide});
        } 
    }


    /**
     * Updates the factura in the parent element in it's current position
     * 
     * @param factura Object instace of Factura
     * TextField
     */
    updateModel(factura, line, blur) {
        if (line === this.props.line)
        this.props.handleInputChange(factura, line, blur);
    }

    formatDate(fecha) {
        let day = fecha.getUTCDate() < 10 ? '0' + fecha.getUTCDate() : fecha.getUTCDate(),
            month = (fecha.getUTCMonth() + 1) < 10 ? '0' + (fecha.getUTCMonth() + 1) : fecha.getUTCMonth() + 1,
            year = fecha.getUTCFullYear();
            
        return moment(fecha).format('DD-MM-YYYY');
    }
    
    render() {
        //Hides the form inputs unless the users types in numeroDoc
        let hide = {display: this.state.isActive || this.props.factura.numeroDoc.length > 0 ? 'inline-block' : 'none'};
        
        let CloseButton = null;

        let DocumentoAfectado = null;

        let docLabel = 'Número de Factura';

        if (this.props.factura.tipo === '02') docLabel = 'Número de Nota de Débito';
        if (this.props.factura.tipo === '03') docLabel = 'Número de Nota de Crédito';

        //Do not render a close button on the first item
        if (this.props.line !== 1) CloseButton = (
            <div style={{position:'relative'}}>
                <Close 
                    style={{position:'absolute', right:1, zIndex:1 }}
                    onTouchTap={this.props.handleQuitarFactura.bind(this, this.props.line)}/>
            </div>
        );

        if (this.props.factura.tipo === '02' || this.props.factura.tipo === '03') {
            DocumentoAfectado = (
                <div style={hide} className="col-xs-12">
                    <Input
                        validations="required,max:20"
                        val={this.props.factura.documentoAfectado}
                        name="documentoAfectado"
                        floatingLabelText="Documento Afectado" 
                        fullWidth={true}
                        onChange={this.handleInputChange}
                        debounce={400} />
                </div>
            );
        }

        return (
            
            <Card style={cardStyle}>

                {CloseButton}

                <CardHeader
                    style={cardHeaderStyle}
                    titleStyle={{fontSize:20}}
                    textStyle={cardHTextStyle}
                    title={"Linea #" + this.props.line}
                    actAsExpander={false}
                    showExpandableButton={false} />

                <div className="row">
                    <div className="col-xs-12">
                        <label htmlFor="tipo">Tipo de Documento</label>
                         <RadioButtonGroup 
                            name="tipo"
                            onChange={this.handleInputChange} 
                            defaultSelected="01" 
                            value={this.props.factura.tipo}>

                            <RadioButton
                                value="01"
                                label="Factura"
                                style={{display:'inline-block'}}
                            />

                            <RadioButton
                                value="02"
                                label="Nota de Débito"
                                style={{display:'inline-block'}}
                            />

                            <RadioButton
                                value="03"
                                label="Nota de Crédito"
                                style={{display:'inline-block'}}
                            />
                         </RadioButtonGroup>
                    </div>

                    <div className="col-xs-12">

                        <Input
                            validations="required,max:20"
                            val={this.props.factura.numeroDoc || ''}
                            onChange={this.handleInputChange} 
                            name="numeroDoc"
                            floatingLabelText={docLabel}
                            fullWidth={true}
                            debounce={400} />

                    </div>
                    
                    <div style={hide} className="col-xs-12">

                        <Input
                            date={true}
                            formatDate={this.formatDate}
                            locale={navigator.language}
                            DateTimeFormat={Intl.DateTimeFormat}
                            validations="date"
                            onChange={this.handleInputChange}
                            val={this.props.factura.fechaFact}
                            name="fechaFact"
                            floatingLabelText="Fecha Documento" 
                            fullWidth={true}
                            floatingLabelStyle={{zIndex:0}}
                            debounce={400} />
                    </div>

                    {DocumentoAfectado}

                    

                    <div style={hide} className="col-xs-12">

                        <Input
                            validations="required,max:20"
                            val={this.props.factura.noControl}
                            name="noControl"
                            floatingLabelText="Nro. Control / Serial" 
                            fullWidth={true}
                            onChange={this.handleInputChange}
                            debounce={400} />

                    </div>
                    
                </div>

                <div className="row">

                    

                    <div style={hide} className="col-xs-12">

                        <Input
                            validations="required,decimal" 
                            name="sinCredito"
                            val={this.props.factura.sinCredito.fmtd()}
                            editVal={this.props.factura.sinCredito}
                            onBlurs={() => null}
                            floatingLabelText="Compras Sin Crédito Fiscal" 
                            fullWidth={true}
                            onBlurs={this.handleInputChange}
                            inputStyle={{textAlign:'right'}}
                            debounce={0} />

                    </div>
                    <div  style={hide} className="col-xs-12">

                        <Input
                            validations="required,decimal" 
                            val={this.props.factura.baseImponible.fmtd()}
                            editVal={this.props.factura.baseImponible}
                            name="baseImponible"
                            floatingLabelText="Base Imponible" 
                            fullWidth={true}
                            
                            onBlurs={this.handleInputChange}
                            inputStyle={{textAlign:'right'}}
                            debounce={10} />
                    </div>
                </div>

                <div className="row">
                    <div style={hide} className="col-xs-4">

                        <Input
                            disabled={true}
                            name="iva"
                            val={parseFloat(this.props.factura.iva).fmtd()}
                            fullWidth={true}
                            floatingLabelText={"I.V.A. "+this.props.factura.porcentaje_iva+"%"}
                            inputStyle={{textAlign:'right', color: 'rgba(0, 0, 0, 0.64)'}}
                            debounce={400}
                        />
                        
                    </div>
                    <div style={hide} className="col-xs-1">
                        <Plus 
                            tooltipPosition="top-center" 
                            tooltip={"Ajustar Decimales del I.V.A. Actual: "+this.props.factura.iva_offset/100}
                            onTouchTap={this.handleInputChange.bind(this, 'plus')}/>
                        <Remove 
                            onTouchTap={this.handleInputChange.bind(this, 'minus')}
                            tooltipPosition="bottom-center" 
                            tooltip={"Ajustar Decimales del I.V.A. Actual: "+this.props.factura.iva_offset/100} />
                    </div>

                    <div style={hide} className="col-xs-4 col-xs-offset-3">
                    
                        <Input
                            disabled={true}
                            val={parseFloat(this.props.factura.retencion).fmtd()}
                            name="retencion"
                            fullWidth={true}
                            floatingLabelText="Retención"
                            inputStyle={{textAlign:'right', color: 'rgba(0, 0, 0, 0.64)'}}
                            debounce={400}
                        />

                    </div>

                    <div style={hide} className="col-xs-12">

                        <Input 
                            disabled={true}
                            val={parseFloat(this.props.factura.totalCompra).fmtd()}
                            name="totalCompra"
                            floatingLabelText="Total Compras (Inc. I.V.A.)" 
                            fullWidth={true}
                            inputStyle={{textAlign:'right', color: 'rgba(0, 0, 0, 0.64)'}}
                            debounce={400} />

                    </div>

                    <div style={hide} className="col-xs-12">

                        <Input 
                            disabled={true}
                            val={parseFloat(this.props.factura.totalPagar).fmtd()}
                            name="totalPagar"
                            floatingLabelText="Total a Pagar" 
                            fullWidth={true}
                            inputStyle={{textAlign:'right', color: 'rgba(0, 0, 0, 0.64)'}}
                            debounce={400} />

                    </div>

                </div>
            </Card>
        );
    }
}

export default FacturaForm;


/** WEBPACK FOOTER **
 ** ./app-react/components/Forms/FacturaForm.jsx
 **/